/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d6c387b6cdf01d178e89f35ca2cc613>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian apps, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const FormIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "FormIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M2.5 14.5h11V13h-11zM7 9v1.5H1V9zM2.5 5.5h11V4h-11zM7 0v1.5H1V0zm8 14.625c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625v-1.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375zm0-9C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625v-1.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
FormIcon.displayName = 'FormIcon';
var _default = exports.default = FormIcon;